import { useContext, useEffect, useRef, useState } from "react";
import "./Header.css";
import { ConfigContext } from "../../assets/contexts/configContext";
import { Link, NavLink } from "react-router-dom";
import {
  CART_MAIN_LINK,
  CATALOG_MAIN_LINK,
} from "../../assets/utils/constants";
import { CartIcon, CloseIcon, MenuIcon, SearchIcon } from "../../assets/icons/icons";
import mainApi from "../../assets/api/MainApi";
import CatalogDrop from "./CatalogDrop/CatalogDrop";
import MenuPopup from "./MenuPopup/MenuPopup";
import { CartContext } from "../../assets/contexts/cartContext";
import useScrollDirection from "../../assets/hooks/useScrollDirection";
import { getURLRelativePath, isExternalURL } from "../../assets/utils/utils";
import Search from "../Search/Search";
import useWindowSize from "../../assets/hooks/useWindowSize";

const desiredOrder = ["Вино", "Шампанское", "Виски", "Коньяк", "Пиво", "Ликёры", "Водка"];

const orderMap = desiredOrder.reduce((map, name, index) => {
  map[name] = index;
  return map;
}, {});

function Header() {
  const scrollDirection = useScrollDirection();
  const { width } = useWindowSize();
  const [searchOpen, setSearchOpen] = useState(false)

  const config = useContext(ConfigContext);
  const cart_context = useContext(CartContext)
  const {
    cart,
    handleAddToCart,
    handleRemoveFromCart,
    setCart,
  } = cart_context
  const { initialConstants } = config
  const { FIRST_LEVEL_CATEGORIES, HEADER_LINKS } = initialConstants

  const catalogBtnRef = useRef(null);
  const linksRef = useRef(null);

  const [isCatalogOpen, setCatalogOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [scrollWindowPosition, setScrollWindowPosition] = useState(0);
  const [popupScrollPosition, setPopupScrollPosition] = useState(0);
  const [visibleCategories, setVisibleCategories] = useState([]);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollWindowPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.top = `-${scrollWindowPosition}px`;
      setPopupScrollPosition(scrollWindowPosition);
      setTimeout(() => {
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.height = "100%";
      }, 10);
    } else {
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
      document.body.style.top = `unset`;
      window.scrollTo(0, popupScrollPosition);
      setScrollWindowPosition(popupScrollPosition);
    }
  }, [isMenuOpen]);


  useEffect(() => {
    if (!HEADER_LINKS || HEADER_LINKS.length === 0) return
    const updateVisibleLinks = () => {
      if (linksRef.current) {
        const maxAllowedWidth = linksRef.current.offsetWidth;
        if (maxAllowedWidth <= 0) return
        let totalWidth = 0;
        const linksToShow = [];

        HEADER_LINKS.forEach((link, index) => {
          const linkElement = document.createElement('div');
          linkElement.className = 'link';
          linkElement.style.visibility = 'hidden';
          linkElement.style.position = 'absolute';
          linkElement.innerText = link.name;
          document.body.appendChild(linkElement);
          const linkWidth = linkElement.offsetWidth + 28 * 2;
          document.body.removeChild(linkElement);

          if (totalWidth + linkWidth <= maxAllowedWidth) {
            linksToShow.push(link);
            totalWidth += linkWidth;
          }
        });

        setVisibleCategories(linksToShow);
      }
    };

    updateVisibleLinks();
    window.addEventListener('resize', updateVisibleLinks);

    return () => window.removeEventListener('resize', updateVisibleLinks);
  }, [HEADER_LINKS]);

  return (
    <>

      <header className={`header  ${scrollDirection === "down" ? searchOpen ? "header_show" : "header_hide" : "header_show"}`}>
        <CatalogDrop
          isOpened={isCatalogOpen}
          setOpened={setCatalogOpen}
          categories={FIRST_LEVEL_CATEGORIES}
          catalogBtnRef={catalogBtnRef}
        />
        <MenuPopup
          isOpened={isMenuOpen}
          setOpened={setMenuOpen}
          categories={FIRST_LEVEL_CATEGORIES}
        />
        <div className="header__content">
          <Link className="header__logo" to={"/"}>
            <svg className="header__logo-img" width="110" height="46" viewBox="0 0 110 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.22847 36.4127L18.8408 26.9413L18.8414 26.94C20.1651 25.7685 21.2686 24.6823 22.1515 23.6808C23.0337 22.6793 23.6958 21.5932 24.1373 20.4217C24.5787 19.2508 24.7994 17.8246 24.7994 16.1444C24.7994 13.8194 24.2646 11.7484 23.1951 9.93212C22.1422 8.11587 20.6992 6.69031 18.8661 5.65482C17.0324 4.60201 15.08 4.07592 12.6528 4.07592C10.2256 4.07592 8.06977 4.58535 6.18536 5.6035C4.30096 6.60499 2.8153 8.00585 1.72906 9.80477C0.721513 11.4844 0.188717 13.4266 0.130038 15.633C0.124701 15.8577 0.306076 16.043 0.530789 16.043H5.17915C5.39252 16.043 5.57057 15.8764 5.57856 15.663C5.62057 14.5842 5.9073 13.5733 6.43941 12.6312C7.03356 11.579 7.85706 10.7389 8.90929 10.1108C9.97886 9.46608 11.2265 9.14334 12.5508 9.14334C13.875 9.14334 15.0466 9.44874 16.0648 10.0602C17.0837 10.6709 17.8812 11.503 18.4587 12.5552C19.0355 13.5907 19.3242 14.7622 19.3242 16.0691C19.3242 17.1045 19.0868 18.14 18.6114 19.1755C18.1533 20.211 17.2791 21.2972 15.9888 22.4347L0.287411 36.5074C0.11938 36.6581 0.0226834 36.8728 0.0213574 37.0988L7.30433e-06 41.0774C-0.00131868 41.2988 0.178059 41.4794 0.400103 41.4794H24.3993C24.6201 41.4794 24.7994 41.3001 24.7994 41.0794V36.8128C24.7994 36.5921 24.6201 36.4127 24.3993 36.4127H8.22847ZM81.5311 20.423C81.0904 21.5945 80.4282 22.6807 79.5454 23.6822L79.5447 23.6835C78.6618 24.685 77.5589 25.7711 76.2346 26.9427L65.6223 36.414H81.7932C82.0139 36.414 82.1933 36.5934 82.1933 36.8141V41.0807C82.1933 41.3014 82.0139 41.4808 81.7932 41.4808H57.7946C57.5726 41.4808 57.3932 41.3008 57.3945 41.0787L57.4159 37.1002C57.4172 36.8741 57.5139 36.6594 57.6819 36.5087L73.3833 22.436C74.6736 21.2985 75.5478 20.2123 76.0059 19.1768C76.4814 18.1414 76.7188 17.1058 76.7188 16.0704C76.7188 14.7635 76.4307 13.592 75.8532 12.5565C75.2758 11.5044 74.4776 10.6722 73.4594 10.0615C72.4405 9.45005 71.3036 9.14468 69.9453 9.14468C68.587 9.14468 67.3734 9.46738 66.3038 10.1121C65.2516 10.7396 64.4281 11.5804 63.8339 12.6325C63.3018 13.5754 63.0151 14.5855 62.9731 15.6643C62.9651 15.877 62.7871 16.0444 62.5737 16.0444H57.9253C57.6999 16.0444 57.5186 15.859 57.5246 15.6343C57.5832 13.428 58.116 11.485 59.1236 9.80611C60.2105 8.00652 61.6955 6.6063 63.5799 5.60484C65.4636 4.58669 67.6201 4.07726 70.0473 4.07726C72.3558 4.07726 74.4269 4.60402 76.26 5.65617C78.0937 6.69165 79.5367 8.11721 80.5889 9.93346C81.6585 11.7491 82.1933 13.82 82.1933 16.1457C82.1933 17.826 81.9726 19.2515 81.5311 20.423ZM43.6969 2.13365H38.4957C38.275 2.13365 38.0957 1.9543 38.0957 1.73358V0.400073C38.0957 0.179352 38.275 0 38.4957 0H43.6969C43.9176 0 44.097 0.179352 44.097 0.400073V1.73358C44.097 1.9543 43.9176 2.13365 43.6969 2.13365ZM28.3869 16.7071C28.3869 14.2261 28.927 12.0318 30.0072 10.1248H30.0079C31.1048 8.21722 32.6071 6.72366 34.5142 5.64349C35.7812 4.91472 37.1761 4.42933 38.6965 4.18461V7.81248C38.6965 8.71997 38.207 9.55139 37.4235 10.0101C37.4177 10.013 37.4123 10.0162 37.4068 10.0196L37.4002 10.0235C36.3026 10.6649 35.4251 11.5424 34.7669 12.6565C34.1088 13.7534 33.7794 14.9769 33.7794 16.3271V36.749C33.7794 38.1159 34.1088 39.3561 34.7669 40.4702C35.1877 41.1717 35.6991 41.7831 36.2999 42.3052C36.4213 42.4106 36.4233 42.5979 36.3039 42.7053L32.7045 45.9317C32.6031 46.0224 32.4491 46.0231 32.3484 45.9317C31.4295 45.0936 30.6487 44.1175 30.0072 43.002C28.927 41.095 28.3869 38.9007 28.3869 36.4197V16.7071ZM43.4968 4.18461C45.0172 4.42933 46.4121 4.91472 47.6791 5.64349L47.6784 5.64282C49.5862 6.72366 51.0798 8.21722 52.1601 10.1241C53.257 12.0311 53.8057 14.2254 53.8057 16.7065V26.6899C53.8057 26.9173 53.7091 27.134 53.5397 27.286L48.858 31.482C48.686 31.636 48.4132 31.514 48.4132 31.2833V16.3264C48.4132 14.9762 48.0838 13.7527 47.4257 12.6559C46.7675 11.5417 45.8813 10.6642 44.7671 10.0228C44.7652 10.0215 44.7632 10.0204 44.7613 10.0193C44.7592 10.018 44.7572 10.0168 44.7551 10.0155C43.9809 9.55341 43.4968 8.72795 43.4968 7.82583V4.18461ZM105.426 7.41908C106.611 8.3559 107.587 9.50074 108.354 10.8549V10.8556C109.451 12.7625 110 14.9569 110 17.4379V28.9163C110 31.3973 109.451 33.5916 108.354 35.4986C107.273 37.4055 105.78 38.9077 103.873 40.0046C102.554 40.7513 101.097 41.2394 99.5044 41.4695C98.8636 41.5621 98.2901 41.0607 98.2901 40.4126V37.2809C98.2901 36.8494 98.5842 36.4694 99.0049 36.3734C99.6964 36.2153 100.348 35.9573 100.961 35.5993C102.075 34.9412 102.961 34.063 103.619 32.9662C104.277 31.8527 104.607 30.6118 104.607 29.245V17.0578C104.607 15.7077 104.277 14.4835 103.619 13.3866C103.058 12.4372 102.33 11.6591 101.437 11.053C101.221 10.9056 101.198 10.5962 101.393 10.4222L104.738 7.43775C104.932 7.2644 105.222 7.25773 105.426 7.41908ZM96.2904 37.2815V40.4113C96.2904 41.0587 95.7176 41.5608 95.0761 41.4681C93.4824 41.2381 92.0267 40.75 90.7078 40.0033C88.8007 38.9064 87.2984 37.4042 86.2015 35.4973C85.1212 33.5903 84.5811 31.396 84.5811 28.9149V25.7858C84.5811 25.5578 84.6785 25.3411 84.8485 25.1891L89.5295 21.0111C89.7009 20.8571 89.9736 20.9791 89.9736 21.2098V29.2443C89.9736 30.6112 90.303 31.8514 90.9612 32.9655C91.6193 34.063 92.4975 34.9405 93.5944 35.5986C94.2172 35.9573 94.8774 36.2153 95.5742 36.3734C95.995 36.4694 96.2904 36.8494 96.2904 37.2815ZM97.56 43.5771L102.412 45.3034H102.412C102.554 45.3533 102.518 45.5621 102.368 45.5621H92.2575C92.1075 45.5621 92.0714 45.354 92.2121 45.3034L97.0219 43.5778C97.1952 43.5151 97.3859 43.5151 97.56 43.5771Z" fill="#B1001B" />
            </svg>
          </Link>
          <div className="header__catalog-with-links">
            <div className="header__catalog">
              {/* <div className='header__categories'>
                        {categories.map((category, i) => (
                            <Link className='header__category' to={`/${CATALOG_MAIN_LINK}/${category.translit_name}`}>
                                {category.title}
                            </Link>
                        ))}
                    </div> */}
              {/* <button className='header__catalog-btn' type='button'>
                        <h3 className='header__catalog-btn-text'>Каталог товаров</h3>
                    </button> */}

              <button
                className="header__catalog-btn"
                type="button"
                ref={catalogBtnRef}
              >
                <CloseIcon
                  mainClassName={`header__catalog-btn-icon header__catalog-btn-icon_close-catalog ${isCatalogOpen
                    ? "header__catalog-btn-icon_close-catalog-open"
                    : ""
                    }`}
                  fillClassName={"header__catalog-btn-icon-fill"}
                />
                <svg
                  className={`header__catalog-btn-icon`}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    className={`header__catalog-btn-icon-fill`}
                    y="6"
                    width="20"
                    height="2"
                    rx="1"
                    fill="white"
                  />
                  <rect
                    className="header__catalog-btn-icon-fill"
                    y="12"
                    width="13"
                    height="2"
                    rx="1"
                    fill="white"
                  />
                </svg>
                <h3 className="header__catalog-btn-text">Каталог</h3>
              </button>
            </div>
            <div className="search_pc">
              <button className="header__input-icon" onClick={() => setSearchOpen(true)} type="button">
                <SearchIcon mainClassName={'header__input-icon'} fillClassName={'header__input-icon-fill'} />
              </button>
              <Search searchOpen={searchOpen} setSearchOpen={setSearchOpen} maxWidth={linksRef && linksRef.current ? linksRef.current.offsetWidth + 28 + 20 : '700px'} />
            </div>

            {HEADER_LINKS && HEADER_LINKS.length > 0 ?
              <div className="header__links" ref={linksRef}>
                {visibleCategories.map((link) => {
                  if (isExternalURL(link.url)) {
                    return (
                      <Link
                        key={link._id}
                        className={`header__link`}
                        to={link.url}
                        target={'_blank'} // Conditionally set target attribute
                        rel={'noopener noreferrer'} // Add rel for security if external
                      >
                        {link.name}
                      </Link>
                    )
                  } else {
                    const relativePath = getURLRelativePath(link.url);
                    return (
                      <NavLink
                        key={link._id}
                        className={({ isActive }) => {
                          return `header__link ${isActive ? 'header__link_active' : ''}`
                        }}
                        to={relativePath}
                      >
                        {link.name}
                      </NavLink>
                    )
                  }
                })}
              </div>
              : null}
          </div>

          <div className="header__cart-and-menu">
            <button className="header__search-icon-mobile" onClick={() => setSearchOpen(true)} type="button">
              <SearchIcon mainClassName={'header__input-icon'} fillClassName={'header__input-icon-fill'} />
            </button>
            <div className="header__cart-box">
              {cart && cart.length > 0 ? (
                <p className="header__cart-count">{cart.length}</p>
              ) : null}
              <Link className="header__cart" to={`/${CART_MAIN_LINK}`}>
                <h3 className="header__cart-text">Корзина</h3>
                <CartIcon
                  mainClassName={"header__cart-icon"}
                  fillClassName={"header__cart-icon-fill"}
                />
              </Link>
            </div>
            <button
              className="header__menu"
              type="button"
              onClick={() => {
                setMenuOpen(true);
              }}
            >
              <MenuIcon
                mainClassName={"header__menu-icon"}
                fillClassName={"header__menu-icon-fill"}
              />
            </button>
          </div>

          <div className="search_mobile">

            <Search searchOpen={searchOpen} setSearchOpen={setSearchOpen} maxWidth={`100%`} />
          </div>

        </div>
      </header >
    </>
  );
}

export default Header;
